import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";

import { DETACH_POLICY_FROM_INTENT_PROJECT } from "./gql";

const useDetachPolicyMutation = createDefaultMutationHook(DETACH_POLICY_FROM_INTENT_PROJECT);

const useDetachPolicyFromIntentProject = (refetchQueries?: string[]) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [detachPolicy, { loading }] = useDetachPolicyMutation({
    refetchQueries,
  });

  const handleDetachPolicy = useCallback(
    (attachmentId: string, successCallback?: () => void) => {
      detachPolicy({ id: attachmentId }, (data) => {
        if (data?.policyIntentProjectDetach) {
          reportSuccess({
            message: "Policy was successfully detached",
          });
          successCallback?.();
        }
      });
    },
    [detachPolicy, reportSuccess]
  );

  return {
    detachPolicy: handleDetachPolicy,
    loading,
  };
};

export default useDetachPolicyFromIntentProject;
